export const TOGGLE_PRO_BLOCK = 'TOGGLE_PRO_BLOCK';

export function toggleProBlock(proBlock){
    return{
        type: TOGGLE_PRO_BLOCK,
        mainState: {
            proBlock: proBlock
        }
    }
}